<div class="modal-header">
  <h5 class="modal-title d-flex gap-2 align-items-center">
    <i class="fal fa-calendar"></i>
    <ng-container i18n>Schedule AI</ng-container>&nbsp;- [{{ data.date | epochUTC : 'dddd, MMMM D, YYYY' }}]
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="px-3">
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex align-items-center justify-content-center px-3 py-2 bg-default rounded align-input-row-end">
          <app-form-switch
            [inline]="true"
            [formControl]="fullDayOffCtrl"
            labelPosition="before"
            [matTooltip]="fullDayOffTooltip"
            >AI full day off</app-form-switch
          >
        </div>
      </div>
      <div class="col-md-6">
        <app-timezone-select [ctrl]="form.get('timezone')"></app-timezone-select>
      </div>
    </div>
    <div class="">
      <div class="form-label text-uppercase" i18n>Choose When AI should be Off</div>
      <ul
        class="list-unstyled d-flex flex-column gap-1 p-3 bg-default rounded"
        style="max-height: 300px; overflow: auto"
      >
        <li
          *ngFor="let slot of timeSlots"
          class="d-flex align-items-center justify-content-center rounded py-1 px-3 cursor-pointer position-relative"
          (click)="slot.checked = !slot.checked"
          [ngClass]="{
            'bg-secondary-danger': slot.checked,
            'border-danger': slot.checked,
            'text-danger': slot.checked,
            border: !slot.checked,
            'bg-white': !slot.checked
          }"
          [style.opacity]="fullDayOffCtrl.value ? 0.5 : 1"
          [style.pointerEvents]="fullDayOffCtrl.value ? 'none' : 'auto'"
        >
          {{ slot.label }}
          <i
            class="fas fa-times position-absolute"
            style="right: 10px; top: 50%; transform: translateY(-50%)"
            *ngIf="slot.checked"
          ></i>
        </li>
      </ul>
    </div>
    <div *ngIf="allDaysAIOffCalendarItems.length > 0">
      <div class="form-label text-uppercase">AI Off for all days</div>
      <ul
        class="list-unstyled d-flex flex-column gap-1 p-3 bg-default rounded"
        style="max-height: 300px; overflow: auto"
      >
        <li
          *ngFor="let item of allDaysAIOffCalendarItems"
          class="d-flex align-items-center justify-content-center rounded py-1 px-3 position-relative border-danger bg-secondary-danger text-danger"
        >
          {{ item.start.format('h A') }} - {{ item.end.format('h A') }}
          <a
            href="javascript:void(0)"
            (click)="removeAllDaysAIOffCalendarItem(item)"
            class="position-absolute text-danger d-inline-flex"
            style="right: 10px; top: 50%; transform: translateY(-50%)"
          >
            <i class="cs-icon cs-icon-trash"></i>
          </a>
        </li>
      </ul>
    </div>
  </form>
</div>
<div class="modal-footer">
  <app-form-switch
    [inline]="true"
    [formControl]="applyToAllDaysCtrl"
    labelPosition="before"
    [matTooltip]="applyToAllDaysTooltip"
    >Apply it to all days</app-form-switch
  >
  <div class="flex-fill"></div>
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
